// extracted by mini-css-extract-plugin
module.exports = {"customerRatings":"CustomerRating_customerRatings__X_F62"};